// extracted by mini-css-extract-plugin
var _1 = "Badge-modulebadge__qXIgU";
var _2 = "Badge-modulebig__knV1x";
var _3 = "Badge-moduleerror__vhTE0";
var _4 = "Badge-modulemedium__WI1HC";
var _5 = "Badge-modulesmall__cly4v";
var _6 = "Badge-moduletheme__cnytF";
export { _1 as "badge", _2 as "big", _3 as "error", _4 as "medium", _5 as "small", _6 as "theme" }
